import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth-context";
import { Navbar } from "@/components/Navbar";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/borrow/$id")({
  head: () => pageHead({ path: "/borrow", title: "Borrow a book — Book Swap", description: "Arrange to borrow a book from a neighbour on Book Swap.", noindex: true }),
  component: Borrow,
});

function Borrow() {
  const { id } = Route.useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    (async () => {
      if (!user) {
        sessionStorage.setItem("post_login_borrow", id);
        navigate({ to: "/login" });
        return;
      }
      const { data: book } = await supabase.from("books").select("id,user_id,status").eq("id", id).maybeSingle();
      if (!book) { toast.error("Book not found."); navigate({ to: "/browse" }); return; }
      if (book.user_id === user.id) { navigate({ to: "/book/$id", params: { id } }); return; }
      if (book.status !== "available") { toast.info("This book isn't available."); navigate({ to: "/book/$id", params: { id } }); return; }
      const { error } = await supabase.from("exchange_requests").insert({
        book_id: id, requester_id: user.id, message: "QR borrow request — let's meet!",
      });
      if (error) toast.error("Couldn't send borrow request."); else toast.success("Borrow request sent! 📚");
      navigate({ to: "/book/$id", params: { id } });
    })();
  }, [user, loading, id, navigate]);

  return <div className="min-h-screen bg-background"><Navbar /><p className="p-12 text-center text-muted-foreground">📷 Sending your borrow request…</p></div>;
}
